import React, {useState, useEffect} from "react";
import axios from "axios";
import { BaseUrl } from "../../../../Actions/Base";
import OtpPoupupImg from "../Assets/OtpPoupup.png";

const OtpVerificationSettingsPopup = ({userEmail, setOtpVerificationShowPopup, setCreateNewPasswordShowPopup }) => {
  const Border = "border-[#E2E2E2] border-[1px] border-solid";
  const [otp, setOtp] = useState(new Array(6).fill("")); // Array for OTP inputs
  const [error, setError] = useState(""); // Error message
  const [resendDisabled, setResendDisabled] = useState(false);
  const [timer, setTimer] = useState(0);

  const handleChange = (element, index) => {
    const value = element.value.replace(/[^0-9]/g, ""); // Only allow numbers
    if (value.length > 1) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Move to next input field if digit entered
    if (value && index < otp.length - 1) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const closePopup = () =>{
      console.log("Close icon clicked");
      setOtpVerificationShowPopup(false);
  }

    const axiosInstance = axios.create({
      baseURL: BaseUrl,
      withCredentials: true,
    });

    const handleSubmit = async () => {
      const fullOtp = otp.join(""); // Combine array to string
      console.log("Submit", fullOtp);
  
      if (fullOtp.length < 6) {
        setError("Please enter a valid 6-digit OTP.");
        return;
      }
  
      const payload = {
        token: JSON.parse(localStorage.getItem("token")),
        OTP: fullOtp,
      };
  
      try {
        const res = await axiosInstance.post("/api/verify-otp", payload);
        console.log(res);
  
        if (res?.data?.success === true) {
          setCreateNewPasswordShowPopup(true);
          setOtpVerificationShowPopup(false);
        } else if (res?.data?.success === false) {
          setError(res?.data?.message);
        }
      } catch (err) {
        console.log(err);
        setError(err?.response?.data?.message || "An error occurred.");
      }
    };

    useEffect(() => {
      let interval;
      if (resendDisabled && timer > 0) {
        interval = setInterval(() => {
          setTimer((prev) => prev - 1);
        }, 1000);
      } else if (timer === 0 && resendDisabled) {
        setResendDisabled(false);
      }
      return () => clearInterval(interval);
    }, [resendDisabled, timer]);

    const OpenOtpPopup = async () => {

      const changePassEmail = userEmail;
        const payload = {
          Email: changePassEmail,
        };
      try {
        const res = await axiosInstance.post("/api/forgot-password", payload);
        console.log(res);
        if (res?.data?.success === true) {
          
          localStorage.setItem(
            "token",
            JSON.stringify(res?.data?.ResetPasswordToken)
          );

          // Start timer
          setResendDisabled(true);
          setTimer(60); // 60 seconds

        } else if (res?.data?.success === false) {
        }

      } catch (err) {
        console.log(err);
      }
    };

    return (
      <div className="fixed inset-0 z-[99] flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-md transition duration-500">
        <div className="relative rounded-[9px] bg-[linear-gradient(270deg,_#D7D9FF_0%,_#FFFFFF_100%)] px-[30px] pb-[30px] shadow-lg w-[340px] lg:w-[400px]">
        <div className="absolute top-2 right-2">
              <img
                className="absolute right-1 top-[4px] cursor-pointer"
                src={require("../Assets/Cross.svg").default}
                alt=""
                onClick={closePopup}
              />
            </div>

            <div  className="mt-[-120px] flex w-full justify-center items-center">
              <img
                src={OtpPoupupImg}
                alt="img"
              />
            </div>
          
          
          <h2
            className=" mb-2 text-center text-[16px]"
          >
            OTP Verification
          </h2>
          <p className="text-center text-[14px]">A code has been sent to your E-mail <span className="font-bold">{userEmail}</span></p>
          <div className="w-[90%] flex justify-center items-center gap-[10px] mt-[20px] mr-[15px] ml-[17px]">
              {otp.map((value, index) => (
                <input
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  maxLength={1}
                  value={value}
                  onChange={(e) => handleChange(e.target, index)}
                  className={`w-[47px] h-[54px] rounded-md py-2 px-[10px] ${Border} text-bold shadow-[4px_5px_6px_#00000029] text-center`}
                />
              ))}
          </div>
          <p className="text-center text-[14px] mt-[10px]">Did not receive OTP?{" "} 
          {/* <span className="text-[#A1A3EF] cursor-pointer" onClick={OpenOtpPopup}>Resend</span> */}
          {resendDisabled ? (
              <span className="text-[#A1A3EF]">Resend in {timer}s</span>
            ) : (
              <span
                className="text-[#A1A3EF] cursor-pointer"
                onClick={OpenOtpPopup}
              >
                Resend
              </span>
            )}
          </p>
          {error && (
          <p className="text-[#ff0000] text-center mt-2 text-[14px]">{error}</p>
        )}

          <div className="w-full flex flex-col ustify-center items-center gap-[15px] mt-[25px]">
            <button
                className="px-[15px] py-[7px] w-[95%] rounded-[6px] bg-[#A1A3EF] text-[#FFFFFF] text-[14px] cursor-pointer"
                onClick={handleSubmit}
                style={{border:"2px solid #A1A3EF"}}>
               Verify
            </button>

            <p className="text-[14px] text-center cursor-pointer" onClick={closePopup}>Back</p>
          </div>
        </div>
      </div>
    );
  };

export default OtpVerificationSettingsPopup;
